export const topResults = "P7d";
export const allResults = "Q7d";
export const pinned = "R7d";
export default {topResults,allResults,pinned};